import Vue from 'vue';
import RemainsListTable from './RemainsListTable.vue';

$(document).ready(function() {
  const container = $('#remains-list-container');
  if (container.length) {
    new Vue({
      el: '#remains-list-container',
      template: '<RemainsListTable />',
      components: {RemainsListTable},
      data: container.data(),
    });
  }
});
